import React, { useState } from "react";

type ShowIfProps = {
  condition: boolean;
  children: JSX.Element;
};

const ShowIf = ({ children, condition }: ShowIfProps) => {
  if (!condition) return null;
  return children;
};

export default ShowIf;
